import moment from 'moment';

import { DIAGNOSTIC_ASSESSMENT_OPTIONS } from '../../../../common';
import { INTAKE_REFERRAL_PAYLOAD_FIELDS } from './constants';
import { REFERRAL_FORM_SCHEMA } from './validationSchema';
import { API_DATE_FORMAT } from '../../../../../../constants';

import type { ReferralFieldName, ReferralFormValues } from '../../../../../common';
import type {
  IIntakeReferral,
  IntakeReferralPayload,
} from '../../../../../../store/questionnaires/intake';

export function toIntakeReferralPayload(values: ReferralFormValues): IntakeReferralPayload {
  return {
    diagnosis_tool: values.diagnosis_tool,
    diagnosis_date: values.referral_date?.format(API_DATE_FORMAT) ?? null,
    provider_name: values.provider_name,
    diagnosis_city: values.city,
    diagnosis_state: values.state,
  };
}

export function toIntakeReferralFieldPayload<K extends ReferralFieldName>(
  name: K,
  values: ReferralFormValues,
): IntakeReferralPayload {
  const payloadField = INTAKE_REFERRAL_PAYLOAD_FIELDS[name];
  const data: IntakeReferralPayload = {};
  data[payloadField] = toIntakeReferralPayload(values)[payloadField];
  return data;
}

export function mapIntakeReferralRowToValues(row: IIntakeReferral): ReferralFormValues {
  return {
    referral_date: row.diagnosis_date ? moment(row.diagnosis_date) : null,
    provider_name: row.provider_name ?? '',
    diagnosis_tool: row.diagnosis_tool ?? '',
    city: row.diagnosis_city ?? '',
    state: row.diagnosis_state ?? '',
  };
}

export function getIntakeReferralRowLabel(row: IIntakeReferral): string {
  return (
    DIAGNOSTIC_ASSESSMENT_OPTIONS.find((item) => item.value === row.diagnosis_tool)?.label ??
    row.diagnosis_tool ??
    ''
  );
}

export function areIntakeReferralsComplete(rows: ReadonlyArray<IIntakeReferral>): boolean {
  return rows.every((row) => REFERRAL_FORM_SCHEMA.isValidSync(mapIntakeReferralRowToValues(row)));
}
